<template>
  <div class="container">
    <breadcrumb></breadcrumb>
    <div class="select-box input_left">
      <Input v-model="searchAppName" style="width:150px;" placeholder="请输入角色"/>
    </div>
    <div class="select-box input_left_two">
      <Select v-model="searchStatus" style="width:150px;" placeholder="请选择状态">
        <Option :value="1">正常</Option>
        <Option :value="0">停用</Option>
      </Select>
    </div>
    <div class="select-box input_left_three">
      <Button type="primary" @click="searchBtn" style="margin-right:5px;">查询</Button>
      <Button type="primary" @click="searchClear">重置</Button>
    </div>
    <div class="select-box">
      <Button type="primary" @click="newAlert" style="margin-right:5px;">新增</Button>
    </div>
    <div class="app-list-table">
      <Table :loading="tableLoading" ref="selection" @on-selection-change="tableOnSelect" class="spacingTwice" border :columns="columns" :data="dataList"></Table>
      <Page show-total :total="total" :current="current" :page-size="pageSize"
          @on-change="pageChange" @on-page-size-change="pageSizeChange" show-sizer />
    </div>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="batchErrArrFlag"
      title="信息提示"
      @on-ok="clearErrArr()"
    >
    </Modal>
    <Modal
      width="600"
      :mask-closable="false"
      v-model="newdata"
      :title="editId ? editFlag ? '查看' : '编辑角色' : '新增角色'"
      :loading="loading"
      @on-ok="editData('formValidate')">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
        <FormItem label="角色" prop="roleName">
          <Input :disabled="editFlag" v-model="formValidate.roleName" maxlength="20" show-word-limit placeholder="请输入角色名称，支持汉字、字母、数字" />
        </FormItem>
        <FormItem label="权限管理" prop="permissionIds">
          <CheckboxGroup v-model="formValidate.all" @on-change="checkAll">
            <Checkbox :disabled="editFlag" label="全部权限"></Checkbox>
          </CheckboxGroup>
          <CheckboxGroup class="permission_son" v-model="formValidate.permissionIds" @on-change="checkOne">
            <div v-for="item in permissionList" :key="item.id">
              <Checkbox :disabled="editFlag" :label="item.name"></Checkbox>
              <div v-show="item.children" v-for="sItem in item.children" :key="sItem.id" class="permission_son_s">
                  <Checkbox :disabled="editFlag" :label="sItem.name"></Checkbox>
              </div>
            </div>
            </CheckboxGroup>
        </FormItem>
        <FormItem label="状态" prop="status">
          <RadioGroup v-model="formValidate.status">
            <Radio :disabled="editFlag" label="正常"></Radio>
            <Radio :disabled="editFlag" label="停用"></Radio>
          </RadioGroup>
          <p style="color:#c00">*角色停用后，该角色下的用户权限也会停用，请谨慎停用</p>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="formValidate.remark" :disabled="editFlag" placeholder="备注最大字数为50字" maxlength="50" show-word-limit type="textarea" :rows="4" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb'
import https from '../../https'
export default {
  name: 'esApp',
  data () {
    return {
      loading: true,
      tableLoading: true,
      newdata: false,
      authorized: false,
      editId: '',
      userList: [],
      userInfoId: '',
      searchAppName: '',
      searchStatus: '',
      currentIndex: '',
      isShowSpin: false,
      tableSelectRow: [],
      batchErrArrFlag: false,
      formValidate: {
        all: '',
        roleName: '',
        remark: '',
        permissionIds: [],
        status: '正常'
      },
      ruleValidate: {
        roleName: [
          { required: true, message: '请输入角色名称，支持汉字、字母、数字', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9\u4e00-\u9fa5]+$/, message: '不符合规范,请重新输入', trigger: 'blur' }
          // { type: 'string', max: 20, min: 1, message: '请输入角色名称，支持汉字、字母、数字', trigger: 'blur' }
        ],
        permissionIds: [{ required: true, message: '请选择权限' }],
        status: [{ required: true, message: '请选择状态', trigger: 'blur' }]
        // apk_pkg: { required: true, pattern: /^[a-zA-Z0-9]+\.[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)*$/g, message: '示例：tv.huan.vibes.test' }
      },
      columns: [ // table表格
        {
          title: '角色',
          key: 'roleName',
          width: 200,
          align: 'center'
        },
        {
          title: '状态',
          key: 'status',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let status = ''
            switch (params.row.status) {
              case 0:
                status = '停用'
                break
              case 1:
                status = '正常'
                break
            }
            let html = [
              h('span', status)
            ]
            return html
          }
        },
        {
          title: '说明',
          key: 'remark',
          align: 'center',
          width: 300
        },
        {
          title: '创建时间',
          key: 'createTime',
          align: 'center',
          width: 200
        },
        {
          title: '更新时间',
          key: 'updateTime',
          align: 'center',
          width: 200
        },
        {
          title: '操作',
          width: 220,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: (params.row.roleName === '超级管理员')
                  // (params.row.createBy !== this.userName
                },
                style: {
                  width: '50px',
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.newAlert(params.index)
                  }
                }
              }, '编辑')
              // h('Button', {
              //   props: {
              //     type: 'primary',
              //     size: 'small'
              //   },
              //   style: {
              //     width: '70px',
              //     marginRight: '10px'
              //   },
              //   on: {
              //     click: () => {
              //       this.newAlert(params.index, 'lock')
              //     }
              //   }
              // }, '查看')
            ])
          }
        }
      ],
      editFlag: false,
      permissionList: [],
      copyList: [],
      categoryList: [],
      dataSource: [], // table数据源
      tvpList: [],
      dataList: [], // tab当前页数据
      total: 0, // tab总条数
      pageSize: 10, // 每页多少条
      current: 1, // 当前页
      userName: ''
    }
  },
  components: {
    breadcrumb
  },
  created () {
    if (!https.token) {
      this.$router.push('/')
      return
    }
    this.userName = localStorage.getItem('userName')
    this.loadData()
    this.getPermission()
  },
  watch: {
    'formValidate.permissionIds' (nVal, oVal) {
      console.log('=-=-==', nVal, oVal)
      if (nVal.length > oVal.length) {
        let addData = nVal.filter(value => !oVal.includes(value))
        this.permissionList.map(item => {
          if (item.name === addData[0]) {
            if (item.children) {
              item.children.map(sItem => {
                if (!this.formValidate.permissionIds.includes(sItem.name)) {
                  this.formValidate.permissionIds.push(sItem.name)
                }
              })
            }
          }
          if (item.children) {
            item.children.map(sItem => {
              if (addData[0] === sItem.name) {
                // console.log('选中了子项，父勾选')
                if (!this.formValidate.permissionIds.includes(item.name)) {
                  this.formValidate.permissionIds.push(item.name)
                }
              }
            })
          }
        })
        console.log('新加', addData)
      } else if (nVal.length < oVal.length) {
        let delData = oVal.filter(value => !nVal.includes(value))
        this.permissionList.map(item => {
          if (item.name === delData[0]) {
            console.log(item.children)
            if (item.children) {
              item.children.map((sItem) => {
                this.formValidate.permissionIds.map((ssItem, ssIndex) => {
                  if (sItem.name === ssItem) {
                    this.formValidate.permissionIds.splice(ssIndex, 1)
                  }
                })
              })
            }
          }
        })
        this.formValidate.all = ''
        console.log('删除', delData)
      }
    }
  },
  mounted () {
  },
  methods: {
    checkOne (val) {
      console.log(val)
    },
    handleGroupChange (val) {
      // console.log(val)
      // const groupPermissions = this.getGroupPermissions(val)
      // if (groupPermissions) {
      //   if (groupPermissions.children && val) {
      //     groupPermissions.children.find(item => {
      //       if (item.parentId === val && !this.formValidate.permissionIds.includes(groupPermissions.name)) {
      //         this.formValidate.permissionIds.push(groupPermissions.name)
      //       }
      //     })
      //   }
      // }
    },
    getGroupPermissions (groupId) {
      const group = this.permissionList.find(group => group.id === groupId)
      return group
    },
    tableOnSelect (row) {
      this.tableSelectRow = row
    },
    pageSizeChange (size) {
      this.pageSize = size
      this.current = 1
      this.loadData()
    },
    // 页数切换
    pageChange (page) {
      this.current = page
      this.loadData()
    },
    searchBtn () {
      this.loadData()
    },
    searchClear () {
      this.searchAppName = ''
      this.searchStatus = ''
      this.loadData()
    },
    clearUserId () {
      this.loadData()
    },
    // 加载tabs列表
    loadData (id = '') {
      let params = {
        // order: 'desc',
        // column: 'createTime',
        pageSize: this.pageSize,
        pageNo: this.current,
        roleName: `${this.searchAppName}`,
        status: this.searchStatus
      }
      this.isShowSpin = true
      https.request({
        method: 'get',
        url: 'role/list',
        headers: {
          'Content-Type': 'application/json',
          'satoken': https.token
        },
        params: params
      }).then(res => {
        console.log(res)
        this.tableLoading = false
        this.isShowSpin = false
        this.dataList = res.data.records
        this.total = res.data.total
        // this.setData()
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    newAlert (index, flag = 'noLock') {
      this.$refs['formValidate'].resetFields()
      console.log(index)
      if (!isNaN(index)) {
        console.log(index, this.dataList)
        this.formValidate = {
          roleName: this.dataList[index].roleName,
          remark: this.dataList[index].remark,
          permissionIds: this.getAllNameList(this.dataList[index].permissionIds || 'all'),
          status: this.dataList[index].status === 1 ? '正常' : '停用'
        }
        this.editId = this.dataList[index].id
        this.currentIndex = index
        this.editFlag = (flag === 'lock')
      } else {
        this.editId = ''
        this.editFlag = false
      }
      this.newdata = true
    },
    checkAll (val) {
      if (val.length === 0) {
        this.formValidate.permissionIds = []
      } else {
        this.formValidate.permissionIds = this.getAllName()
      }
    },
    getPermission () {
      https.request({
        method: 'get',
        url: 'permission',
        headers: {
          'Content-Type': 'application/json',
          'satoken': https.token
        }
      }).then(res => {
        console.log(res)
        this.permissionList = res.data
        this.copyList = res.data
        this.copyList.map(item => {
          item['flag'] = false
        })
      })
    },
    clearErrArr () {
      this.batchErrArrFlag = false
    },
    getAllNameList (str) {
      let s = str.split(',')
      let oArr = []
      let arr = []
      this.permissionList.map(pItem => {
        oArr.push(pItem)
        if (pItem.children) {
          pItem.children.map(sItem => {
            oArr.push(sItem)
          })
        }
      })
      if (str === 'all') {
        oArr.map(item => {
          arr.push(item.name)
        })
      } else {
        s.map(item => {
          oArr.map(oItem => {
            if (Number(item) === oItem.id) {
              arr.push(oItem.name)
            }
          })
        })
      }
      return arr
    },
    getAllName () {
      let oArr = []
      this.permissionList.map(item => {
        oArr.push(item.name)
        if (item.children) {
          item.children.map(sItem => {
            oArr.push(sItem.name)
          })
        }
      })
      return oArr
    },
    getId (list) {
      let arr = []
      let oArr = []
      this.permissionList.map(item => {
        oArr.push(item)
        if (item.children) {
          oArr.push(...item.children)
        }
      })
      list.map(item => {
        oArr.map(pItem => {
          if (item === pItem.name) {
            arr.push(pItem.id)
          }
        })
      })
      return arr.join(',')
    },
    editData (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.changeLoading()
            if (this.formValidate.roleName.trim().length === 0) {
              this.$Message.error('卡片名称不能为空')
              return
            }
            console.log(this.formValidate.permissionIds)
            let params = {
              roleName: this.formValidate.roleName.trim(),
              permissionIds: this.getId(this.formValidate.permissionIds),
              status: this.formValidate.status === '正常' ? 1 : 0,
              remark: this.formValidate.remark
            }
            if (this.editId) {
              params['id'] = this.editId
              https.request({
                method: 'post',
                url: 'role/edit',
                headers: {
                  'Content-Type': 'application/json',
                  'satoken': https.token
                },
                data: params
              }).then(res => {
                if (res.data && res.data.code === 400) {
                  this.$Message.error(res.data.msg)
                  this.newdata = false
                  this.loadData()
                  return
                }
                if (res.data && res.data.code === 500) {
                  this.$Message.error(res.data.msg)
                  return
                }
                this.$Message.success('提交成功')
                this.newdata = false
                this.loadData()
              }).catch(error => {
                this.$Message.error(error)
              })
            } else {
              https.request({
                method: 'post',
                url: 'role/add',
                headers: {
                  'Content-Type': 'application/json',
                  'satoken': https.token
                },
                data: params
              }).then(res => {
                if (res.code === 500) {
                  this.$Message.error(res.msg)
                  return
                }
                this.$Message.success('提交成功')
                this.newdata = false
                this.loadData()
              }).catch(error => {
                this.$Message.error(error)
              })
            }
          }, 1000)
        } else {
          this.changeLoading()
        }
      })
    },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .container{
    position: relative;
  }
  .file-wrap {
    position: relative;
    display: inline-block;
    margin-bottom: 10px;
    .file-input {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
  .env-btn {
    display: flex;
    justify-content: space-between;
    button {
      width: 140px;
    }
  }
  .select-box{
    display: flex;
    position: absolute;
    top: 20px;
    right: 160px;
    .select-label{
      line-height: 32px;
      margin-right: 10px;
    }
  }
  .select-box-type{
    display: flex;
    position: absolute;
    top: 20px;
    right: 60px;
  }
  .select-box-type-pl{
    display: flex;
    position: absolute;
    top: 20px;
    right: 260px;
  }
  .input_left{
    left:207px;
    // left:407px;
  }
  .input_left_two{
    left:380px;
    // left:580px;
  }
  .input_left_three{
    left:555px;
    // left:755px;
  }
  .app_aduit_stats{
    position: absolute;
    top:0px;
    right:0px;
  }
  .app_close_stats{
    position: absolute;
    top:0px;
    left:4px;
  }
  .app-list-table{
    padding:40px 0;
  }
  .agreement_title{
    text-align: center;
    font-size:20px;
    font-weight: bold;
  }
  .agreement_text{
    width:700px;
    // border:1px solid #000;
    height:500px;
    overflow-y: auto;
    margin-left:50px;
  }
  #copyinput{
    position: absolute;
    bottom: -30px;
  }
  .card-spin-container{
        display: inline-block;
        width: 100%;
        height: 100%;
        // position: relative;
    }
  .permission_son{
    margin-left:20px;
  }
  .permission_son_s{
    margin-left:20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/authority/esRole.vue